import { useRef, useState } from 'react';
import type { VirtuosoHandle } from 'react-virtuoso';
import { VirtualScrollContext } from './hooks';
import type { Data } from './types';

type Props = React.PropsWithChildren;

export const VirtualScrollProvider = ({ children }: Props) => {
  const [isFocused, setIsFocused] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(-1);

  const dataRef = useRef<Data | undefined>(undefined);
  const virtuosoRef = useRef<VirtuosoHandle>(null);

  const value = {
    currentIndex,
    dataRef,
    isFocused,
    setCurrentIndex,
    setIsFocused,
    virtuosoRef
  };

  return (
    <VirtualScrollContext.Provider value={value}>
      {children}
    </VirtualScrollContext.Provider>
  );
};
